import { TimelineMax } from 'gsap';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';

$(document).ready(() => {

  let controller = new ScrollMagic.Controller();

  if($('.g--main > section:nth-of-type(1)').length) {

    // Compact header
    new ScrollMagic.Scene({
      triggerElement: '.g--main > section:nth-of-type(1)',
      triggerHook: 0,
      offset: -$('.g--header').height() + 30
    })
    .setClassToggle('.g--header', 'g--header-compact')
    .addTo(controller);

  }

  // Shapes
  if($('[data-sm="products-block"]').length) {

    new ScrollMagic.Scene({
      triggerElement: '[data-sm="products-block"]',
      reverse: false,
      triggerHook: 1,
      offset: 0
    })
    .on('start', function (e) {

      $('[data-sm="products-block"]').addClass('shape--animated');

      window.lazyOverseer($('[data-sm="products-block"]'));

    })
    .addTo(controller);

  }

  if($('[data-sm="productnav"]').length) {

    new ScrollMagic.Scene({
      triggerElement: '[data-sm="productnav"]',
      reverse: true,
      triggerHook: 0,
      offset: -$('.g--header').height() + ($(window).width() > 1210 ? 28 : ($(window).width() > 976 ? 17 : ($(window).width() > 753 ? 28 : 38))) // - 53 (as 'top' .s.s--productnav .productnav)
    })
    .setClassToggle('[data-sm="productnav"]', 's--productnav-sticky')
    .addTo(controller);

  }

  if($('[data-sm="performance-block"]').length) {

    new ScrollMagic.Scene({
      triggerElement: '[data-sm="performance-block"]',
      reverse: false,
      triggerHook: 1,
      offset: 0
    })
    .on('start', function (e) {

      $('[data-sm="performance-block"]').addClass('shape--animated');

      setTimeout(() => {

        $('[data-animate="performance-e1"]').addClass('fadeInLeft animated');


        setTimeout(() => {

          $('[data-animate="performance-e2"]').addClass('fadeInLeft animated');

          // iframe

          if($('[data-animate="performance-e2"] .js-iframe-lazy').length) {

            let ei = $('[data-animate="performance-e2"] .js-iframe-lazy');
            ei.attr('src', ei.attr('data-s'));

            window.lazyOverseer($('[data-animate="performance-e2"]'));

          }

        }, 200);

        setTimeout(() => {

          $('[data-animate="performance-e3"]').addClass('fadeInLeft animated');

        }, 400);

        setTimeout(() => {

          $('[data-animate="performance-e4"]').addClass('fadeInLeft animated');

        }, 600);

        setTimeout(() => {

          $('[data-animate="performance-e5"]').addClass('fadeInUp animated');

        }, 1000);

        setTimeout(() => {

          $('[data-animate="performance-e6"]').addClass('fadeInUp animated');

        }, 1100);

      }, 1500);

    })
    .addTo(controller);

  }

  if($('[data-j="product-nav"]').length) {

    $('[data-j="product-nav"]').each((i, e2) => {
      
      new ScrollMagic.Scene({
        triggerElement: e2.currentTarget,
        reverse: true,
        triggerHook: 1,
        offset: 0
      })
      .on('start', function (e) {

        // console.log(e)

      })
      .addTo(controller);

    });

  }

  // Product nav

  if($('[data-sm="product-features"]').length) {

    new ScrollMagic.Scene({
      triggerElement: '[data-sm="product-features"]',
      reverse: true,
      triggerHook: 0,
      offset: -$('.g--header').height() - 90 // - 53 (as 'top' .s.s--productnav .productnav)
    })
    .on('start', function (e) {

      $('.js-product-nav > li').removeClass('active');

      $('[data-target="product-features"]').addClass('active');

      window.lazyOverseer($('[data-sm="product-features"]'));

    })
    .addTo(controller);

  }

  if($('[data-sm="product-benefits"]').length) {

    new ScrollMagic.Scene({
      triggerElement: '[data-sm="product-benefits"]',
      reverse: true,
      triggerHook: 0,
      offset: -$('.g--header').height() - 90 // - 53 (as 'top' .s.s--productnav .productnav)
    })
    .on('start', function (e) {

      $('.js-product-nav > li').removeClass('active');

      $('[data-target="product-benefits"]').addClass('active');

      window.lazyOverseer($('[data-target="product-benefits"]'));

    })
    .on('leave', function (e) {

      $('.js-product-nav > li').removeClass('active');

      $('[data-target="product-features"]').addClass('active');
      
    })
    .addTo(controller);

  }

  if($('[data-sm="product-gallery"]').length) {

    new ScrollMagic.Scene({
      triggerElement: '[data-sm="product-gallery"]',
      reverse: true,
      triggerHook: 0,
      offset: -$('.g--header').height() - 90 // - 53 (as 'top' .s.s--productnav .productnav)
    })
    .on('start', function (e) {

      $('.js-product-nav > li').removeClass('active');

      $('[data-target="product-gallery"]').addClass('active');

      window.lazyOverseer($('[data-target="product-gallery"]'));


    })
    .on('leave', function (e) {

      $('.js-product-nav > li').removeClass('active');

      $('[data-target="product-benefits"]').addClass('active');

    })
    .addTo(controller);

  }

  if($('[data-sm="product-comparison"]').length) {

    new ScrollMagic.Scene({
      triggerElement: '[data-sm="product-comparison"]',
      reverse: true,
      triggerHook: 0,
      offset: -$('.g--header').height() - 90 // - 53 (as 'top' .s.s--productnav .productnav)
    })
    .on('start', function (e) {

      $('.js-product-nav > li').removeClass('active');

      $('[data-target="product-comparison"]').addClass('active');

      window.lazyOverseer($('[data-target="product-comparison"]'));

    })
    .on('leave', function (e) {

      $('.js-product-nav > li').removeClass('active');

      $('[data-target="product-gallery"]').addClass('active');

    })
    .addTo(controller);

  }

  if($('[data-sm="product-specs"]').length) {

    new ScrollMagic.Scene({
      triggerElement: '[data-sm="product-specs"]',
      reverse: true,
      triggerHook: 0,
      offset: -$('.g--header').height() - 90 // - 53 (as 'top' .s.s--productnav .productnav)
    })
    .on('start', function (e) {

      $('.js-product-nav > li').removeClass('active');

      $('[data-target="product-specs"]').addClass('active');

      window.lazyOverseer($('[data-target="product-specs"]'));

    })
    .on('leave', function (e) {

      $('.js-product-nav > li').removeClass('active');

      $('[data-target="product-comparison"]').addClass('active');

    })
    .addTo(controller);

  }

  if($('[data-sm="media-block"]').length) {

    new ScrollMagic.Scene({
      triggerElement: '[data-sm="media-block"]',
      reverse: false,
      triggerHook: 1,
      offset: 0
    })
    .on('start', function (e) {

      $('[data-sm="media-block"]').addClass('shape--animated');

      window.lazyOverseer($('[data-sm="media-block"]'));

    })
    .addTo(controller);

  }

  if($('[data-sm="social-block"]').length) {

    new ScrollMagic.Scene({
      triggerElement: '[data-sm="social-block"]',
      reverse: false,
      triggerHook: 1,
      offset: 0
    })
    .on('start', function (e) {

      $('[data-sm="social-block"]').addClass('shape--animated');

      window.lazyOverseer($('[data-sm="social-block"]'));

    })
    .addTo(controller);

  }

  // new ScrollMagic.Scene({
  //   triggerElement: '[data-vue="init"]',
  //   reverse: false,
  //   triggerHook: 1,
  //   offset: 0
  // })
  // .on('start', function (e) {

  //   window.vueEnvInit();

  // })
  // .addTo(controller);


});
